
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/specification",
      function () {
        return require("private-next-pages/specification.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/specification"])
      });
    }
  